import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {ConfirmationDialogModel} from '../../typings/models/confirmation-dialog.model';
import {Observable} from 'rxjs';
import {ConfirmationDialogComponent} from '../components/confirmation-dialog/confirmation-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogProviderService {
  constructor(private dialog: MatDialog) {}

  showConfirmationDialog(data: ConfirmationDialogModel, widthSize?: string): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: widthSize ?? '400px',
      data
    });

    return dialogRef.afterClosed();
  }
}
